import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatCarHireResultCard, RuleActionExtension } from '@sabstravtech/obtservices/base';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { formatCardCurrency, policyStatusClass, policyStatusLabel } from '../chat-card.util';

@Component({
  selector: 'app-chat-car-hire-card',
  standalone: false,
  templateUrl: './chat-car-hire-card.component.html',
  styleUrls: ['./chat-car-hire-card.component.scss']
})
export class ChatCarHireCardComponent {
  @Input() card!: ChatCarHireResultCard;
  @Output() carSelect = new EventEmitter<ChatCarHireResultCard>();

  faLocationDot = faLocationDot;

  get policyClass(): string {
    return policyStatusClass(this.card.policyStatus);
  }

  get policyLabel(): string {
    return policyStatusLabel(this.policyClass);
  }

  get isBlocked(): boolean {
    return this.card.policyStatus === 'UNAVAILABLE';
  }

  /** This quote's policy fields, shaped for `app-warning-tags` — the same
   *  indicator/tooltip component the results page uses, so the chat card and
   *  results page render identically instead of a bespoke text box. */
  get headlineWarningTicket(): RuleActionExtension {
    return {
      unavailable: !!this.card.unavailable,
      unavailableMessage: this.card.unavailableMessage || '',
      requiresReasonKeys: this.card.requiresReasonKeys || [],
      requiresReasonMessages: this.card.requiresReasonMessages || []
    };
  }

  get formattedPrice(): string {
    return this.formatPrice(this.card.price, this.card.currencyCode ?? 'GBP');
  }

  get formattedPricePerDay(): string | null {
    if (!this.card.pricePerDay) {
      return null;
    }
    return this.formatPrice(this.card.pricePerDay, this.card.currencyCode ?? 'GBP') + '/day';
  }

  private static readonly SPECIAL_VENDORS = ['AL', 'ZL', 'ZE', 'SX'];

  get vendorLogoClass(): string {
    const code = this.card.vendorCode;
    if (!code) return '';
    if (code === 'ZE') return 'car-hire-card__vendor-logo--ze';
    if (ChatCarHireCardComponent.SPECIAL_VENDORS.includes(code))
      return 'car-hire-card__vendor-logo--special';
    return '';
  }

  private formatPrice(amount: number, currencyCode: string): string {
    return formatCardCurrency(amount, currencyCode);
  }

  select(): void {
    if (this.card.unavailable) return;
    this.carSelect.emit(this.card);
  }

  logoLoadError = false;
}
